export const REDIRECT_AUTHENTICATED_PATH = '/admin/promotions/dealer/mystery-shopper'
